import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import { TranslatableString } from '@rjsf/utils';
/** The `AddButton` renders a button that represent the `Add` action on a form
 */
export default function AddButton(_a) {
    var { uiSchema, registry } = _a, props = __rest(_a, ["uiSchema", "registry"]);
    const { translateString } = registry;
    return (_jsx(IconButton, Object.assign({ title: translateString(TranslatableString.AddItemButton) }, props, { color: 'primary' }, { children: _jsx(AddIcon, {}) })));
}
//# sourceMappingURL=AddButton.js.map